import { type FunctionComponent, type ReactNode, useState } from 'react';

import { Checkbox } from '@dr.pogodin/react-utils';

import { EQUIPMENT_KINDS } from 'utils';

import type { CheckboxGroupPropsT } from '../common';

import '../common.scss';

const Equipment: FunctionComponent<CheckboxGroupPropsT> = ({
  setSpecs,
  specs,
}) => {
  const [customEquipment, setCustomEquipment] = useState<string>('');

  const equipmentSet = new Set(specs.equipmentNeedsV2);
  const content: ReactNode[] = [];

  for (const equipment of EQUIPMENT_KINDS) {
    const checked = equipmentSet.has(equipment);
    content.push(
      <Checkbox
        checked={checked}
        key={equipment}
        label={equipment}
        onChange={() => {
          setSpecs({
            ...specs,
            equipmentNeedsV2: checked
              ? specs.equipmentNeedsV2.filter((item) => item !== equipment)
              : [...specs.equipmentNeedsV2, equipment],
          });
        }}
      />,
    );
  }

  content.push(<div key="separator" styleName="separator" />);

  for (let i = 0; i < specs.customEquipmentRequirements.length; ++i) {
    const equipment = specs.customEquipmentRequirements[i];
    if (!equipment) throw Error('Missing equipment');
    content.push(
      <Checkbox
        checked
        key={`custom/${i}/${equipment}`}
        label={equipment}
        onChange={() => {
          const customEquipmentRequirements = [
            ...specs.customEquipmentRequirements,
          ];
          customEquipmentRequirements.splice(i, 1);
          setSpecs({ ...specs, customEquipmentRequirements });
        }}
      />,
    );
  }

  content.push(
    <input
      key="custom-modality-input"
      onChange={(e) => {
        setCustomEquipment(e.target.value);
      }}
      onKeyDown={(e) => {
        if (customEquipment && (e.key === 'Enter' || e.key === 'Tab')) {
          if (!specs.customEquipmentRequirements.includes(customEquipment)) {
            setSpecs({
              ...specs,
              customEquipmentRequirements: [
                ...specs.customEquipmentRequirements,
                customEquipment,
              ],
            });
          }
          setCustomEquipment('');
        }
      }}
      placeholder="Other"
      styleName="plainInput"
      value={customEquipment}
    />,
  );

  return (
    <div styleName="checkboxGroup">
      <div styleName="checkboxGroupTitle">Equipment Requirements</div>
      {content}
    </div>
  );
};

export default Equipment;
